import NotationResponseDialog from '../../../../shared-components/Notation/NotationResponseDialog';
import React, { useContext } from 'react';
import { IAction } from '../../../../shared-interfaces/Notation/IAction';
import { IMethodOfContact } from '../../../../shared-interfaces/Notation/IMethodOfContact';
import {
  NotationManagementState,
  NotationManagementDispatch,
} from '../NotationManagement';
import { NotationManagementActionType } from '../types/NotationManagementActionType';
import { useSnackbar } from 'notistack';
import ReactGA from 'react-ga';
import AlertService from '../../../../shared-services/Notation/AlertService';
import { Inclusion } from '../../../../shared-types/Inclusion';
import { ICoreUser } from '../../../../shared-interfaces/User/ICoreUser';

interface IMassLowerAlert {
  open: boolean;
  close: () => void;
}

const MassLowerAlert = (props: IMassLowerAlert) => {
  const state = useContext(NotationManagementState);
  const dispatch = useContext(NotationManagementDispatch);
  const { enqueueSnackbar, closeSnackbar } = useSnackbar();
  return (
    <NotationResponseDialog
      open={props.open}
      close={props.close}
      title="Bulk lower open alerts"
      defaultText="Alert lowered via bulk operation."
      handleResponse={async (
        action: IAction,
        details: string,
        assignedTo?: ICoreUser,
        methodOfContact?: IMethodOfContact,
      ) => {
        let ret = false;
        const ids = (state.selectAll
          ? state.excludedNotations
          : state.selectedNotations
        )
          .filter(x => x.notationType === 'Alert' && x.alertStatus === 'Open')
          .map(x => x.id);
        // filters endpoint
        ret = await AlertService.bulkLower(
          action.id,
          details,
          state.selectAll ? Inclusion.Exclude : Inclusion.Include,
          methodOfContact?.id,
          state.filters.categories.map(x => x.id),
          state.filters.createdBy?.id,
          state.filters.createdFor?.id,
          state.filters.startDate,
          state.filters.endDate,
          ids,
        );
        if (ret) {
          dispatch({
            type: NotationManagementActionType.LowerAlerts,
            ids: (state.selectAll
              ? state.notations.filter(
                  x =>
                    state.excludedNotations.findIndex(
                      y => x.indexId === y.indexId,
                    ) === -1,
                )
              : state.selectedNotations
            )
              .filter(
                x => x.notationType === 'Alert' && x.alertStatus === 'Open',
              )
              .filter(
                x =>
                  state.excludedNotations.findIndex(
                    y => x.indexId === y.indexId,
                  ) === -1,
              )
              .map(x => x.id),
          });
        }
        if (ret) {
          ReactGA.event({
            category: 'NotationManagement',
            action: 'AlertsMassLowered',
            label: state.selectAll
              ? JSON.stringify({
                  ...state.filters,
                  excludedNotations: state.excludedNotations,
                })
              : JSON.stringify({ selected: state.selectedNotations.length }),
          });

          enqueueSnackbar('Lowered Alerts', { variant: 'success' });
        } else {
          enqueueSnackbar('Failed to Lower Alerts', { variant: 'error' });
        }
        return ret;
      }}
    />
  );
};

export default MassLowerAlert;
